export const isAnyItemIsTooLong = items => {
  const maxString = Math.max(...items.map(({
    name,
    count
  }) => `${name}${count ? ` (${count})` : ''}`.length));
  return maxString > 13;
};